<template>
  <div class="complete-kantei">
    <div class="complete-kantei__body">
      <img class="complete-kantei__figure" src="/static/img/mail_icon.svg" />
      <p class="complete-kantei__lead">
        お申し込みありがとうございました。<br>
        占い師による鑑定が完了しましたらご登録のメールアドレスへ動画をお届けします。「<a href="/payment/library">申込・購入済み</a>」からも確認いただけます。
      </p>
    </div>
    <div class="complete-kantei__foot">
      <h3 class="complete-kantei__subheading">注意事項</h3>
      <p class="complete-kantei__description">
        動画のお届けなど、お客様へのお知らせは、help@uranai.tvまたは、info@uranai.tvよりお送りします。受信設定のご確認をお願いします。また、お申し込み後の内容変更や払い戻しは承っておりませんので、予めご了承ください。
      </p>
      <base-button
        class="complete-kantei__button"
        tag="a"
        label="OK"
      />
    </div>
  </div>
</template>

<script>
import BaseButton from '../common/BaseButton'

export default {
  name: 'CompleteKantei',
  components: {
    BaseButton
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.complete-kantei {
  padding: 35px 4px 20px;
  color: $col_base_black;
  line-height: 1.6;
  &__body {
    padding: 0 0 30px;
  }
  &__figure {
    display: block;
    margin: 0 auto 30px;
  }
  &__lead {
    font-size: 13px;
    text-align: justify;
    margin: 0 0 5px;
  }
  &__subheading {
    font-size: 12px;
    font-weight: 400;
    margin: 0 -20px 16px;
    padding: 8px 20px;
    background: linear-gradient(56.98deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
  }
  &__description {
    margin: 0 0 25px;
    font-size: 11px;
    text-align: justify;
  }
  a {
    color: inherit;
  }
}
</style>

<style lang="scss">
.complete-kantei .baseButton__button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/CompleteKantei.vue